import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import OtpInput from "./components/OtpInput";
import SidebarLayout from './components/SidebarLayout';
import NoSidebarLayout from './components/NoSidebarLayout';
import ProtectedRoute from "./components/ProtectedRoute";
import UsersComponent from "./components/Users";
import Orders from "./components/Orders";
import Location from "./components/Location";
import Owners from "./components/Owners";
import Locks from "./components/Locks";
import Schedules from "./components/Schedules";
import BoxPrices from "./components/BoxPrices";

const App = () => {
  const [phoneNumber, setPhoneNumber] = useState("");

  return (
    <Router>
      <Routes>
        <Route element={<ProtectedRoute><SidebarLayout /></ProtectedRoute>}>
          <Route
            path="/"
            element={
                <Orders/>
            }
          />
          <Route
            path="/users"
            element={
                <UsersComponent/>
            }
          />
          <Route
            path="/owners"
            element={
                <Owners/>
            }
          />
          <Route
            path="/locks"
            element={
                <Locks/>
            }
          />
          <Route
            path="/schedules"
            element={
                <Schedules/>
            }
          />
          <Route
            path="/locations/:id"
            element={
                <Location/>
            }
          />
          <Route
            path="/locations/:id/boxprices/:boxId"
            element={
                <BoxPrices/>
            }
          />
        </Route>
        <Route element={<NoSidebarLayout />}>
          <Route
              path="/login"
              element={
                !phoneNumber ? (
                  <Login onNext={setPhoneNumber} />
                ) : (
                  <OtpInput phoneNumber={phoneNumber} onLogin={() => (window.location = "/")} />
                )
              }
            />
            {/* <Route
                path="*"
                element={<Navigate to="/" replace={true} />}
            /> */}
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
